<template>
    <div :class="{ 'prevent-clicks': isLoading }">
        <section class="basket-products mb-4">
            <h1>{{ $t('basket.cart') }}</h1>

            <template v-if="items.length">
                <div class="hidden-until-lg">
                    <div class="basket-header d-flex justify-content-between">
                        <div class="basket-header-item">{{ $t('basket.product') }}</div>
                        <div class="basket-header-item basket-header-item-count">{{ $t('basket.count') }}</div>
                        <div class="basket-header-item basket-header-item-price">{{ $t('basket.price') }}</div>
                    </div>
                </div>

                <basket-item
                    v-for="(item, index) in items"
                    :key="item.id"
                    :item="item"
                />
            </template>
            <template v-else>
                <p>{{ $t('basket.empty') }}</p>
            </template>
        </section>

        <section v-if="upsellItems.length" class="mb-4">
            <h3>{{ $t('basket.upsell') }}</h3>
            <div class="cards">
                <div class="scrollable-container">
                    <product-card
                        v-for="product in upsellItems"
                        @addedToCart="fetchBasket"
                        :key="product.id"
                        :product="product"
                    />
                </div>
            </div>
        </section>

        <basket-summary v-if="items.length" />

        <div v-show="isLoading" class="basket-updating">
            <p class="text-center mb-1">{{ $t('basket.updating') }}</p>
            <spinner />
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import BasketItem from '@/_vue/components/basket/item';
    import BasketSummary from '@/_vue/components/basket/summary';
    import ProductCard from '@/_vue/components/product/card';
    import Spinner from '@/_vue/components/ui/spinner';

    export default {
        name: 'Basket',
        components: {
            BasketItem,
            BasketSummary,
            ProductCard,
            Spinner,
        },
        props: {
            basketUrl: {
                required: true,
            },
        },
        created() {
            this.setBasketDefaults({
                basketRoute: this.basketUrl,
            });

            this.fetchBasket();
        },
        computed: {
            ...mapState('basket', {
                isLoading: 'isLoading',
                items: 'items',
                upsellItems: 'upsellItems',
            }),
        },
        methods: {
            ...mapActions('basket', [
                'fetchBasket',
            ]),

            ...mapMutations('basket', [
                'setBasketDefaults',
            ]),
        },
    };
</script>
